export function buildTaskRouteFromNotice(notice) {
  const item = notice || {}
  const query = {
    fromNotice: '1'
  }
  if (item.id) {
    query.noticeId = item.id
  }
  if (item.targetPlanId) {
    query.planId = item.targetPlanId
  }
  if (item.targetStageId) {
    query.stageId = item.targetStageId
  }
  if (item.targetMaterialId) {
    query.materialId = item.targetMaterialId
  }
  if (item.targetExamId) {
    query.examId = item.targetExamId
  }
  if (item.targetTaskType) {
    query.taskType = item.targetTaskType
  }
  return {
    path: '/center/tasks',
    query
  }
}
